/* global http loadEventSliderWithThumbnail*/
const serviceModalGallery = {
	el: {
		body: document.querySelector('body'),
		mainWrapperPage: document.querySelector('.wrapper'),
		modalContainer: document.querySelector('.aside-gallery-modal'),
		toggleModal: document.querySelectorAll('.js-modal-gallery-toggle')
	},

	fxToggleModal(e, index) {
		// check if parent element has class that opens modal
		if (e.currentTarget.closest('.aside-gallery').classList.contains('modal-opened')) {
			// if yes  we remove class and class that hide scrollbar
			e.currentTarget.closest('.aside-gallery').classList.remove('modal-opened')
			this.el.body.classList.remove('no-scroll-hidden')

		}
		else {
			// if not we add class on parent / hide scrollbar and call api
			e.currentTarget.closest('.aside-gallery').classList.add('modal-opened')
			this.el.body.classList.add('no-scroll-hidden')

			// we receive index in order to check which image on gallery has been clicked
			this.fxHandleApiCall(index)
		}
	},

	fxHandleApiCall(index) {
		// get attributes in order to call api
		const apiEndPoint = this.el.mainWrapperPage.getAttribute('data-action-modal-gallery')
		const hostelId = this.el.mainWrapperPage.getAttribute('data-hostel-id')

		// concat attributes
		const finalEndPoint = `${apiEndPoint}${hostelId} `

		// get language that has to be sent to api
		const languageParameter = this.el.body.getAttribute('data-language')

		// set formData
		const formData = {
			hostelId
		}

		// callback function 
		const callback = (response, data) => this.fxBuildModalGallery(response, data, index)

		// GET function - from @http.js file
		http.fxPost(finalEndPoint, formData, callback, languageParameter)
	},

	fxBuildModalGallery(response, data, index) {
		// check if response is success
		if (response.status === 200) {

			// check if user already opened gallery, if yes we remove everything inside modal
			document.querySelector('.aside-gallery-modal__wrap') && document.querySelector('.aside-gallery-modal__wrap').remove()

			// save container that goes inside aside-gallery-modal
			const modalGalleryContent =
				`
					<div class="aside-gallery-modal__wrap">
						
						<div class="aside-gallery-modal__slider">
							<div class="aside-gallery-modal__slider-main">
								<div
									class="swiper-container js-slider-thumbnail-main">
									<div class="swiper-wrapper">

									</div>
									<div class="swiper-button-next"></div>
									<div class="swiper-button-prev"></div>
								</div>
							</div>
							<div class="aside-gallery-modal__slider-thumbnail">
								<div
									class="swiper-container js-slider-thumbnail">
									<div class="swiper-wrapper">

									</div>
								</div>
							</div>
							<div class="aside-gallery-modal__caption">
								<div class="aside-gallery-modal__caption-heading js-slider-thumbnail-caption-heading">
									${data[index].figCaptionHeading}
								</div>
								<div class="aside-gallery-modal__caption-copy js-slider-thumbnail-caption-copy">
									${data[index].figCaptionCopy}
								</div>
							</div>
						</div>
					</div>	
				`

			// insert wrap container inside container (aside-gallery-modal) that is already in the DOM
			this.el.modalContainer.insertAdjacentHTML('beforeend', modalGalleryContent)

			// create element a in order to addEventListener click on it and work properly close modal action
			const toggleModalButton = document.createElement('a')

			// add class to this element created
			toggleModalButton.classList.add('aside-gallery-modal__close', 'js-modal-gallery-toggle')

			// insert element created inside modal__wrap
			document.querySelector('.aside-gallery-modal__wrap').appendChild(toggleModalButton)

			// addEventListener to this element created
			toggleModalButton.addEventListener('click', e => this.fxToggleModal(e))

			// do a loop in data variable in order to get each content inside array
			data.map(el => {
				// get selector swiper wrapper that is inside modal and insert node element
				document.querySelectorAll('.aside-gallery-modal__slider .swiper-wrapper').forEach(element => element.innerHTML += `
					
					<div class="swiper-slide" data-figcaption-heading="${el.figCaptionHeading}" data-figcaption-copy="${el.figCaptionCopy}">
						<div class="aside-gallery-modal__slider-item">
							<figure class="aside-gallery-modal__slider-figure">
									<img class="aside-gallery-modal__slider-image img-full"
									src="${el.srcImage}" alt="${el.figCaptionHeading}">
							</figure>
						</div>
					</div>
				`)
			})

			// call function of swiper in order to init swiper with thumbnail - index is responsible for set initialSlide once we know which image has been clicked
			loadEventSliderWithThumbnail.fxInitSliderThumbnail(document.querySelector('.js-slider-thumbnail-main'), document.querySelector('.js-slider-thumbnail'), index)
		}
	},

	events() {
		// Responsible for open modal and call api once js-modal-gallery-toggle clicked - We have index as a parameter that is really important in order to check which item as been clicked and then show it first when modal is opened
		document.querySelectorAll('.js-modal-gallery-toggle').forEach((el, index) => el.addEventListener('click', e => this.fxToggleModal(e, index)))
	},

	init() {
		this.events()
	}
}

serviceModalGallery.init()